import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";

export const getCompanies = (axios: IAxiosInstance) => {
  return async () => {
    const response = await axios.noRetry.get<any>(`/api/company`);
    return response.data;
  };
};
